import React from 'react';
import { List, Item, Action } from './style';

const FinancingSolutionsMenu = ({ financingSolutions }) => (
  <List>
    {financingSolutions.map(({ title }) => (
      <Item key={title}>
        <Action smooth to={`#${title}`} scroll={el => { el.scrollIntoView(true); window.scrollBy(0, -90) }}>
          <u>{title}</u>
        </Action>
      </Item>
    ))}
  </List>
);

export default FinancingSolutionsMenu;
